import React, {useState} from 'react';
import {Form, Formik} from "formik";
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {Button} from 'react-bootstrap';
import {Modal} from 'react-bootstrap';
import {DataItem} from "../../../_common/components/DataItem/DataItem";
import can from "../../../_common/components/Permissions/can";
import {integerValue} from '../../../../../utils';
import * as actions from "../../_redux/paymentsActions";

const PopupUpdateAmount = ({cellContent, intl, dispatch}) => {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const prefix = 'automatedPayments-popup-updateAmount';
  const isEnabled = (can('full', 'bituahLeumiPayment') && cellContent.statusID !== 2 && cellContent.statusID !== 4);
  const buttonClassName = `btn btn-icon btn-light btn-sm mx-3 custom-action-button
  ${isEnabled ? `` : `custom-disabled-button cursor-default`}`;
  const debtAmountInitialValue = Boolean(cellContent.debtAmount) ? cellContent.debtAmount : 0;
  const insuranceAmountInitialValue = Boolean(cellContent.insuranceAmount) ? cellContent.insuranceAmount : 0;

  const updateAmountFunc = ({paymentRequestID, debtAmount, insuranceAmount}) => () => {
    dispatch(actions.updateAmountAction({
      paymentRequestID,
      debtAmount,
      insuranceAmount,
      agentID: cellContent?.agentID || '',
      paymentRequestDate: cellContent?.paymentRequestDate || '',
    }));
    setShow(false);
  };

  return (
    <>
      <Button
        className={buttonClassName}
        onClick={() => {
          handleShowModal();
        }}
        title={intl.formatMessage({id: "automatedPayments-button-tooltip-updateAmount", defaultMessage: "Send to create the invoice profitably"})}
        disabled={!isEnabled}
      >
        <img
          src={toAbsoluteUrl('/media/svg/Money_brandColor.svg')}
          alt="update"
        />
      </Button>
      <Modal
        show={show}
        onHide={handleCloseModal}
      >
        <Modal.Body>
          <Formik
            initialValues={{
              debtAmount: debtAmountInitialValue,
              insuranceAmount: insuranceAmountInitialValue,
              totalAmount: debtAmountInitialValue + insuranceAmountInitialValue,
            }}
            onSubmit={() => null}
            enableReinitialize={true}
          >
            {({
                values,
                dirty
              }) => (
              <Form>
                <h3 className="card-title font-weight-bold text-dark text-center">
                  {intl.formatMessage({id: `${prefix}-header`, defaultMessage: "Editing the amount to be paid for social security."})}
                </h3>
                <div className="d-flex flex-column justify-content-around align-items-center w-50 mx-auto">
                  <DataItem
                    fieldId={'debtAmount'}
                    inputContainerStyle={''}
                    label={intl.formatMessage({id: `${prefix}-label-debtAmount`, defaultMessage: "Debt amount"})}
                    value={values.debtAmount}
                    topLabelStyle={'custom-brand-color'}
                    onChange={integerValue}
                  />
                  <DataItem
                    fieldId={'insuranceAmount'}
                    inputContainerStyle={'pt-2'}
                    label={intl.formatMessage({id: `${prefix}-label-insuranceAmount`, defaultMessage: "Insurance amount"})}
                    value={values.insuranceAmount}
                    topLabelStyle={'custom-brand-color'}
                    onChange={integerValue}
                  />
                  <DataItem
                    fieldId={'totalAmount'}
                    inputContainerStyle={'mt-6 mb-10'}
                    label={intl.formatMessage({id: `${prefix}-label-totalAmount`, defaultMessage: "Total amount"})}
                    value={values.debtAmount + values.insuranceAmount}
                    topLabelStyle={'custom-brand-color'}
                    disabled={true}
                  />
                </div>
                <div className="d-flex justify-content-center">
                  <Button className="btn-secondary btn-sm col-3 mx-3 " onClick={handleCloseModal}>
                    {intl.formatMessage({id: "button-cancel", defaultMessage: "Cancel"})}
                  </Button>
                  <Button
                    className="btn-sm col-3 mx-3 custom-send-button"
                    onClick={
                      updateAmountFunc({
                        paymentRequestID: cellContent._id,
                        debtAmount: values.debtAmount || 0,
                        insuranceAmount: values.insuranceAmount || 0,
                      })
                    }
                    disabled={!dirty}
                  >
                    {intl.formatMessage({id: "button-update", defaultMessage: "Update"})}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupUpdateAmount;